module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-00.ff0c51d9.png";